import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { useEffect, useRef } from 'react';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotifications } from '../hooks/use-notifications';
import UnreadIndicator from './unread-indicator';
import { useOpenNotificationMenuQuery } from '../hooks/use-open-notification-menu-query';
import { BellIcon } from '@systemeio/ui/icons';
import { useActualHeaderLayoutType } from 'shared/components/header';
import { NotificationsMenuContent } from './notifications-menu-content';
export interface NotificationMenuProps {
  className?: string;
}
const defaultFilter = {
  onlyUnRead: false
};
export const NotificationMenu = t0 => {
  const $ = _c(19);
  const {
    className
  } = t0;
  const menuRef = useRef(null);
  const menuWasOpenByQueryRef = useRef(false);
  const {
    pagination
  } = usePagination(true);
  let t1;
  if ($[0] !== pagination) {
    t1 = {
      shouldFetchNotifications: false,
      limit: 3,
      pagination,
      filter: defaultFilter
    };
    $[0] = pagination;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    notificationsMeta
  } = useNotifications(t1);
  const {
    isDesktop
  } = useActualHeaderLayoutType();
  const t2 = isDesktop === true;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      allowCheck: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    openThroughQuery,
    setOpenThroughQuery
  } = useOpenNotificationMenuQuery(t3);
  let t4;
  let t5;
  if ($[4] !== openThroughQuery) {
    t4 = () => {
      if (openThroughQuery) {
        menuRef.current?.click();
      }
    };
    t5 = [openThroughQuery];
    $[4] = openThroughQuery;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== openThroughQuery || $[8] !== setOpenThroughQuery) {
    t6 = isShown => {
      setTimeout(() => {
        menuWasOpenByQueryRef.current && !isShown && openThroughQuery && setOpenThroughQuery(false);
        menuWasOpenByQueryRef.current = isShown && openThroughQuery;
      });
    };
    $[7] = openThroughQuery;
    $[8] = setOpenThroughQuery;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const closeMenuOnUnfocusIfOpenedThroughQuery = t6;
  const t7 = openThroughQuery ? "click" : undefined;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      gap: 13,
      to: "top end",
      offset: 135
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <NotificationsMenuContent className="w-[500px] rounded-lg" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== closeMenuOnUnfocusIfOpenedThroughQuery || $[13] !== notificationsMeta?.hasUnread) {
    t10 = show => {
      closeMenuOnUnfocusIfOpenedThroughQuery(show);
      return <div className="focus-visible:border-brand-primary focus:outline-hidden flex h-full items-center justify-around gap-2.5 border-b-4 border-transparent"><div className="text-background-secondary/90 relative w-5 text-sm font-bold"><BellIcon className={twMerge("fill-background-tertiary stroke-background-tertiary hover:fill-background-secondary hover:stroke-background-secondary w-4 transition", show && "fill-background-secondary stroke-background-secondary")} />{notificationsMeta?.hasUnread && <UnreadIndicator className="absolute right-0 top-0 p-0 " iconClassName="w-2 h-2" />}</div></div>;
    };
    $[12] = closeMenuOnUnfocusIfOpenedThroughQuery;
    $[13] = notificationsMeta?.hasUnread;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== className || $[16] !== t10 || $[17] !== t7) {
    t11 = <><Tooltip popoverButtonRef={menuRef} mode={t7} anchor={t8} className={className} stayOnHover={true} popoverClassName="p-0 shadow-lg rounded-lg" wrapperClassName="h-full" label={t9}>{t10}</Tooltip></>;
    $[15] = className;
    $[16] = t10;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};